"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AjaxHelper = void 0;
class AjaxHelper {
    constructor(options) {
        this.options = options;
        this.request = new XMLHttpRequest();
    }
    abort() {
        var _a;
        try {
            this.request.abort();
        }
        catch (ex) {
            (_a = this.options.logger) === null || _a === void 0 ? void 0 : _a.warn('XHR request abort failed');
        }
    }
    send() {
        return new Promise((resolve, reject) => {
            this.request.open(this.options.method, this.options.url, true);
            this.request.onload = () => {
                resolve(this.request.status);
            };
            this.request.onerror = () => {
                reject(this.request.status);
            };
            return this.request.send();
        });
    }
}
exports.AjaxHelper = AjaxHelper;
//# sourceMappingURL=ajax-helper.js.map